<template>
  <div class="login" :style="{minHeight: bodyHeight}">
    <div class="login-header" v-if="false">
      <!-- <div class="login-header-l">
        <img
          src="@assets/img/guoyao-logo.png"
          alt="云展台"
          class="f-csp"
        />
      </div> -->
      <!-- <div class="login-header-r">
        <p @click="$router.push('/exhibition/register')">注册</p>
      </div> -->
    </div>
    <div class="login-content">
      <router-view></router-view>
      <div class="login-content-footer">
        <span class="s1"> </span>
        <span class="s2">Copyright &copy; 2020 Reed Sinopharm Exhibitions Co. Ltd</span>
        <!-- <span class="s1">联展软件技术支持</span> -->
        <!-- <span class="s2">Copyright &copy; {{year}} cmef.com.cn All Rights Reserved.</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "exhibition-login",
  data() {
    return {
      bodyHeight: "800px"
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 登录";
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
    document.getElementsByTagName("body")[0].className = "h-100";
    document.getElementsByTagName("html")[0].className = "h-100";
  },
  methods: {},
  destroyed() {
    document.body.removeAttribute("class", "h-100");
    document.getElementsByTagName("html")[0].className = "";
  }
};
</script>
 
<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: url(./img/bg.png);
  background-repeat: no-repeat;
 background-size:100%  100%;
  &-header {
    width: 100%;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 74px 0 68px;
    &-r p {
      width: 48px;
      height: 24px;
      font-size: 24px;
      line-height: 18px;
      color: #ededed;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &-content {
    width: 100%;
    flex: 1;
    align-items: center;
    position: relative;
    &-footer {
      width: 100%;
      height: 51px;
      position: absolute;
      bottom: 31px;
      color: #000;
      font-weight: bold;
      font-size: 16px;
      .s1 {
        height: 30px;
      }
      .s1 {
        height: 21px;
      }
      .s1,
      .s2 {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
